<template>
  <div>
    <div v-if="payer.current_tariff">
      <div class="title mb-2">Текущий тариф</div>
      <v-card>
        <v-list-item three-line class="px-6 pt-3">
          <v-list-item-content>
            <div class="overline mb-2">Бесплатный период: {{ payer.current_tariff.tariff.free_days || 'нет' }}</div>
            <v-list-item-title class="headline mb-1">Тариф: {{ payer.current_tariff.tariff.name }}</v-list-item-title>
            <v-list-item-subtitle>Цена: {{ payer.current_tariff.tariff.price | price }} руб.</v-list-item-subtitle>
            <v-list-item-subtitle class="mt-1 green--text text--lighten-1">Действует с {{ payer.current_tariff.start_at | date }} по {{ payer.current_tariff.end_at | date }}</v-list-item-subtitle>
            <v-divider class="mx-4 mt-4 mb-4"></v-divider>
            <div>
              <h3 class="mt-2 mb-2">Включает:</h3>
              <ul>
                <li v-for="option in tariffData.current.options" :key="option.key">
                  <span>{{ option.name}}</span>
                </li>
              </ul>
            </div>
            <div v-if="tariffData.current.extendedOptions.length">
              <h4 class="mt-2 mb-2">Расширенные опции:</h4>
              <ul>
                <li v-for="option in tariffData.current.extendedOptions" :key="option.key">
                  <span>{{ option.name}}</span>
                </li>
              </ul>
            </div>
            <div v-if="tariffData.current.constrainOptions.length">
              <h3 class="mt-2 mb-2 red--text">Недоступно:</h3>
              <ul>
                <li v-for="option in tariffData.current.constrainOptions" :key="option.key">
                  <span>{{ option.name}}</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 class="mt-2 mb-2">Редактировать:</h4>
              {{ tariffData.current.getEditableOptions }}
              <div
                v-for="option in tariffData.current.editableOptions"
                :key="option.key"
                style="justify-content: left"
              >
                <v-checkbox
                  v-model="payer.current_tariff[option.option]"
                  :label="option.name"
                  hide-details
                  class="mx-2"/>
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions class="px-6">
          <strong v-if="isCurrentTariffPaused" class="mb-4 red--text text--lighten-1">
            <v-icon class="red--text text--lighten-1">warning</v-icon> Текущий тариф остановлен!
          </strong>
          <div v-if="!isCurrentTaruffPausedNotAvailable">
            <v-btn
              v-if="!isCurrentTariffPaused"
              @click="pauseCurrentTariff(payer.current_tariff.tariff, 'pause')"
              outlined
            >
              <v-icon left>pause</v-icon> Остановить
            </v-btn>
            <v-btn
              v-else-if="isCurrentTariffPaused"
              @click="pauseCurrentTariff(payer.current_tariff.tariff, 'unpause')"
              outlined
            >
              <v-icon left>play_arrow</v-icon> Возобновить
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
      <div class="mt-3">
        <v-btn @click="modals.changeTariff = true">Сменить тариф</v-btn>
      </div>
    </div>
    <div v-else>
      <div>Тарифный план не выбран!</div>
      <v-btn @click="modals.changeTariff = true">Выбрать тариф</v-btn>
    </div>
    <TariffSelector
      :show="modals.changeTariff"
      :tariffs="tariffList"
      :current-tariff="payer.current_tariff"
      :next-tariff="payer.next_tariff"
      :parent="parent"
      contentClass="esh-theme adminModal"
      disable-next-select
      @update:dialog="updateTariffSelectorDialog($event)"
      @tariff:current="setCurrentTariff($event)"
      @tariff:next="setNextTariff($event)"
    />
  </div>
</template>

<script>
import TariffSelector from '@/components/tariffs/TariffSelectorView'
import { debounce } from 'lodash'
import { BASE } from '@/config'
import {
  ADMIN_SET_PAYER_TARIFF,
  ADMIN_RESUME_PAYER_TARIFF,
  ADMIN_UPDATE_PAYER_TARIFF,
  GET_ADMIN_PAYER_TARIFFS,
  ADMIN_PAUSE_PAYER_TARIFF
} from '@/requests/admin'

export default {
  name: 'StudentPayerView',
  components: {
    TariffSelector
  },
  props: {
    student: Object,
    parent: Object,
    payer: Object
  },
  data() {
    return {
      tariffList: [],
      modals: {
        changeTariff: false,
      },
    }
  },
  created() {
    this.debouncedUpdateTariff = debounce(this.updateCurrentTariffOptions, 300)
    this.loadTariffs()
  },
  watch: {
    'payer.current_tariff': {
      handler(value, prevValue) {
        if (prevValue && value && value === prevValue) {
          this.debouncedUpdateTariff(value)
        }
      },
      deep: true
    },
    'parent': {
      handler() {
        this.loadTariffs();
      },
      deep: true
    },
  },
  computed: {
    isCurrentTariffPaused() {
      let currentTariff = this.payer.current_tariff
      return currentTariff.paused_start_at != null && currentTariff.paused_end_at != null
    },
    isCurrentTaruffPausedNotAvailable() {
      let currentTariff = this.payer.current_tariff
      return currentTariff.paused_start_at != null && currentTariff.paused_end_at == null
    },
    tariffData() {
      return {
        current: this.payer.current_tariff ? ({
          ...this.getTariffData(this.payer.current_tariff, this.payer.current_tariff.tariff),
          editableOptions: this.getEditableOptions(this.payer.current_tariff.tariff)
        }) : null,
        next: this.payer.next_tariff ? 
            this.getTariffData(this.payer.next_tariff, this.payer.next_tariff.tariff) :
            null
      }
    },
  },
  methods: {
    getIncludedOptions(tariff) {
      return BASE.TARIFF.options.filter(o => tariff[o.option])
    },
    getTariffData(tariff, originTarff) {
      const includedOptions = this.getIncludedOptions(tariff)
      return {
        options: includedOptions,
        extendedOptions: BASE.TARIFF.options.filter(o => !originTarff[o.option] && tariff[o.option]),
        constrainOptions: includedOptions.filter(o => o.user && (this.parent[o.user] === null || this.parent[o.user] === ''))
      }
    },
    getEditableOptions() {
      const permissions = BASE.TARIFF.permissionToChange.all
      return BASE.TARIFF.options.filter(o => permissions.includes(o.key))
                                .filter(o => !o.user || (o.user && this.parent[o.user]))
    },
    updateTariffSelectorDialog(value) {
      this.modals.changeTariff = value
    },
    isCurrentTariff(id) {
      return this.payer.current_tariff && this.payer.current_tariff.tariff.id === id
    },
    isNextTariff(id) {
      return this.payer.next_tariff && this.payer.next_tariff.tariff.id === id
    },
    async pauseCurrentTariff(tariff, action) {
      try {
        if (action === 'pause') await ADMIN_PAUSE_PAYER_TARIFF(this.parent.parent_id, this.student.id)
        if (action === 'unpause') await ADMIN_RESUME_PAYER_TARIFF(this.parent.parent_id, this.student.id)
        this.$notify({
          type: 'success',
          text: `Тариф ${tariff.name} ${action === 'pause' ? 'остановлен' : 'возобновлен'}!`
        })
        this.$emit('update:payer')
      } catch (error) {
        this.$notify({
          type: 'error',
          text: `Что-то пошло не так! ${tariff.name} не ${action === 'pause' ? 'остановлен' : 'возобновлен'}!`
        })
      }
    },
    async setCurrentTariff(tariff) {
      try {
        await ADMIN_SET_PAYER_TARIFF(this.parent.parent_id, this.student.id, tariff.id)
        this.$emit('update:payer')
        this.$notify({
          type: 'success',
          text: `Тариф ${tariff.name} успешно установлен!`
        })
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: `Что-то пошло не так! Тариф ${tariff.name} не установлен.`
        });
      } finally {
        this.modals.confirmTariff = false
      }
    },
    async updateCurrentTariffOptions() {
      try {
        const updateData = {}
        this.tariffData.current.editableOptions.forEach(o => {
          updateData[o.option] = this.payer.current_tariff[o.option]
        });

        await ADMIN_UPDATE_PAYER_TARIFF(this.parent.parent_id, this.student.id, updateData)
        this.$notify({
          type: 'success',
          text: 'Опции текущего тарифа успешно изменены!'
        })
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось обновить параметры текущего тарифа'
        })
      }
    },
    async loadTariffs() {
      try {
        const { data: { results } } = await GET_ADMIN_PAYER_TARIFFS(this.parent.parent_id, this.student.id)
        this.tariffList = results
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось получить доступные тарифы'
        })
      }
    }
  }
}
</script>